// Suvadi API Service - Centralized API handling with authentication
import { authService } from './auth';

/**
 * Get authentication token from storage or context
 */
const getAuthToken = (): string => {
  // Use the existing auth service to get the real JWT token
  return authService.getToken() || '';
};

/**
 * Create authenticated fetch request
 */
const createAuthenticatedRequest = (options: RequestInit = {}): RequestInit => {
  const token = getAuthToken();
  
  return {
    ...options,
    headers: {
      ...options.headers,
      'Authorization': `Bearer ${token}`,
    },
  };
};

/**
 * Upload document to backend with authentication
 */
export const uploadDocument = async (file: File, userId: string) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('userId', userId);
  
  const requestOptions = createAuthenticatedRequest({
    method: 'POST',
    body: formData,
  });
  
  const response = await fetch('/suvadi/api/v1/documents/upload', requestOptions);
  
  if (!response.ok) {
    const errorText = await response.text();
    console.error('Upload response:', response.status, response.statusText, errorText);
    throw new Error(`Upload failed: ${response.statusText} (${response.status})`);
  }
  
  return response.json();
};

/**
 * Save warranty to backend with authentication
 */
export const saveWarranty = async (warrantyData: any) => {
  const requestOptions = createAuthenticatedRequest({
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(warrantyData),
  });
  
  const response = await fetch('/suvadi/api/warranties', requestOptions);
  
  if (!response.ok) {
    const errorText = await response.text();
    console.error('Warranty save response:', response.status, response.statusText, errorText);
    throw new Error(`Failed to save warranty: ${response.statusText} (${response.status})`);
  }
  
  return response.json();
};

/**
 * Generic authenticated API call
 */
export const apiCall = async (url: string, options: RequestInit = {}) => {
  const requestOptions = createAuthenticatedRequest(options);
  const response = await fetch(url, requestOptions);
  
  if (!response.ok) {
    const errorText = await response.text();
    console.error('API call failed:', url, response.status, response.statusText, errorText);
    throw new Error(`API call failed: ${response.statusText} (${response.status})`);
  }
  
  return response.json();
};
